import { ethers } from 'ethers';
import { getContractAddress } from 'utilities';
import config from 'config';
import dlVaultAbi from 'constants/contracts/abis/dlVault.json';

import { BscChainId } from 'types';

export interface WithdrawXvsInput {
  userSigner: ethers.Signer;
  chainId?: BscChainId;
}

export interface WithdrawXvsOutput {
  success: boolean;
  txHash?: string;
  error?: string;
}

const withdrawXvs = async ({
  userSigner,
  chainId = config.chainId,
}: WithdrawXvsInput): Promise<WithdrawXvsOutput> => {
  try {
    const userAddress = await userSigner.getAddress();
    const dlVault = new ethers.Contract(
      getContractAddress('dlVault'),
      dlVaultAbi,
      userSigner,
    );

    const tx = await dlVault.claimRewards({ from: userAddress });
    await tx.wait();

    return {
      success: true,
      txHash: tx.hash,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
};

export default withdrawXvs;
